import { render, staticRenderFns } from "./CardSelection.vue?vue&type=template&id=152845cc"
import script from "./CardSelection.vue?vue&type=script&lang=js"
export * from "./CardSelection.vue?vue&type=script&lang=js"
import style0 from "./CardSelection.vue?vue&type=style&index=0&id=152845cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports